import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { lpForm } from 'lp-form'
import {
  Field,
  propTypes as formPropTypes,
  formValueSelector,
} from 'redux-form'
import {
  persistSubmitSucceeded,
  formatObjectsToIds,
  parseIdsToObjects,
  replaceResources,
  serializeOptions,
} from 'utils'
import { CheckboxGroup, CheckboxFieldset } from 'components'
import { InputError, SubmitButton } from 'lp-components'
import { modifyProps } from 'lp-hoc'

const propTypes = {
  ...formPropTypes,
  artsEducationResourceTypes: PropTypes.arrayOf(Types.communityEnumerable)
    .isRequired,
  ariaLabelledby: PropTypes.string.isRequired,
}

const defaultProps = {}

const FORM_NAME = 'school-arts-education-resources'
const GROUP_CHECKBOX_ERROR_NAME = `${FORM_NAME}-checkbox-group`

function ArtsEducationResourcesForm({
  handleSubmit,
  isSaving,
  artsEducationResourceTypes,
  saved,
  submitting,
  error,
  ariaLabelledby,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <CheckboxFieldset
        invalid={!!error}
        disabled={isSaving}
        groupValidationErrorId={GROUP_CHECKBOX_ERROR_NAME}
      >
        <Field
          name="artsEducationResources"
          aria-labelledby={ariaLabelledby}
          label={false}
          component={CheckboxGroup}
          options={serializeOptions(artsEducationResourceTypes)}
          format={formatObjectsToIds('artsEducationResourceTypeId')}
          parse={parseIdsToObjects('artsEducationResourceTypeId')}
        />
        {error && (
          <InputError
            name={GROUP_CHECKBOX_ERROR_NAME}
            error={error}
            touched
            invalid
          />
        )}
      </CheckboxFieldset>
      <div className="button-wrapper">
        <SubmitButton {...{ pristine: saved, submitting }}>
          Save Response
        </SubmitButton>
      </div>
    </form>
  )
}

ArtsEducationResourcesForm.propTypes = propTypes
ArtsEducationResourcesForm.defaultProps = defaultProps

const select = formValueSelector(FORM_NAME)

function mapStateToProps(state) {
  return {
    artsEducationResources: select(state, 'artsEducationResources'),
  }
}

function modifyBeforeSubmit({ initialValues }) {
  return {
    beforeSubmit: ({ artsEducationResources }) => {
      const resources = replaceResources({
        old: initialValues.artsEducationResources,
        new: artsEducationResources,
      })
      return { artsEducationResources: resources }
    },
  }
}

export default compose(
  connect(mapStateToProps),
  modifyProps(modifyBeforeSubmit),
  lpForm({
    name: FORM_NAME,
    enableReinitialize: true,
  }),
  persistSubmitSucceeded()
)(ArtsEducationResourcesForm)
